<template>
  <company-custom :companyName="companyName">
    <div class="store-list">
      <div class="header">
        <div class="title" @click="show = true">
          <div>{{ fieldValue }}</div>
          <img class="img" src="@/assets/img/icon_up_arrow.png" alt="" />
        </div>
        <van-popup v-model="show" position="top">
          <van-cascader
            v-model="cascaderValue"
            title="选择区域"
            :options="options"
            :fieldNames="fieldNames"
            @close="show = false"
            @finish="onFinish"
          />
        </van-popup>
      </div>

      <div class="content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="listLoadMore"
        >
          <div class="list" v-for="(item, index) in storelist" :key="index">
            <store-item :item="item"></store-item>
          </div>
        </van-list>
      </div>
    </div>
  </company-custom>
</template>

<script>
import StoreItem from "./store-item.vue";
import CompanyCustom from "@/components/CompanyCustom.vue";
import { safetyInspectionStoreareas, safetyInspectionStores } from "@/common/api.js";
let pageSize = 10;

export default {
  components: {
    StoreItem,
    CompanyCustom,
  },
  data() {
    return {
      companyName: "",
      show: false,
      fieldValue: "选择区域",
      cascaderValue: "",
      fieldNames: {
        text: "areaName",
        value: "areaCode",
        children: "children",
      },
      options: [],
      storelist: [],
      originalStoreList: [],
      pageNum: 1,
      loading: false,
      finished: false,
      userLatitude: "",
      userLongitude: ""
    };
  },
  mounted() {},
  methods: {
    async getCityAreaInfo() {
      try {
        let rs = await safetyInspectionStoreareas({storeType: this.$route.query.productCategoryType});
        if (rs && rs.length > 0) {
          this.options = rs;
        } else {
          this.$toast("该城市暂未开通服务，可尝试其他城市");
        }
      } catch (error) {}
    },
    async getStoreListInfo() {
      try {
        let storeRs = await safetyInspectionStores({
          // orderBy: "01",
          // area: this.cascaderValue || "",
          // userLatitude: this.userLatitude,
          // userLongitude: this.userLongitude,
          longitude: this.userLongitude,
			    latitude: this.userLatitude,
					orderBy: '01',
					areaCode: this.cascaderValue || "",
					storeType: this.$route.query.productCategoryType,
					providerCompanyIds: [],
					enable: 1,
					pageNum: 1,
					pageSize: 1000,
        });
        if (storeRs && storeRs.length > 0) {
          this.originalStoreList = storeRs;
          console.log(this.originalStoreList);
          var arr = this.originalStoreList.concat();
          if (this.originalStoreList.length > pageSize * this.pageNum) {
            arr = arr.splice(0, pageSize * this.pageNum);
            this.finished = false;
          }
          this.storelist = arr;
        } else {
          this.storelist = [];
          this.$toast("该城市暂未开通服务，可尝试其他城市");
        }
      } catch (error) {}
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.areaName).join("/");
      let lastObject = selectedOptions.pop();
      //取最后一个元素的areaCode
      this.cascaderValue = lastObject.areaCode;
      //更新门店数据
      this.getStoreListInfo();
    },
    listLoadMore() {
      this.loading = false;
      this.pageNum = this.pageNum + 1;
      var arr = [];
      let storeListLength = this.storeList ? this.storeList.length : -1;
      let count = storeListLength + pageSize * this.pageNum;
      if (this.originalStoreList.length > count) {
        let originalList = this.originalStoreList.concat();
        arr = originalList.splice(0, count);
      } else {
        arr = this.originalStoreList;
      }
      this.storelist = arr;
      // 显示数据==总数，隐藏上拉加载
      if (this.storelist.length >= this.originalStoreList.length) {
        this.finished = true;
      }
    },
    async getPosition() {
      const _this = this;
      const mapObj = new AMap.Map("iCenter");
      mapObj.plugin("AMap.Geolocation", () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, // 显示定位按钮，默认：true
          buttonPosition: "LT", // 定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        mapObj.addControl(geolocation);
        geolocation.getCurrentPosition(async(status, result) => {
          if (status == "complete") {
            console.log("定位成功");
            _this.userLongitude = result.position.lng;
            _this.userLatitude = result.position.lat;
            console.log(_this.userLongitude, _this.userLatitude);
          } else {
            console.log("定位失败");
            // 定位失败，默认北京
            _this.userLongitude = 116.397428;
            _this.userLatitude = 39.90923;
            _this.cascaderValue = '110000'
            // console.log(_this.userLongitude, _this.userLatitude);
            // console.log(result,'error');
          }
          await this.getStoreListInfo();
        });
      });
    },
  },
  async created() {
    this.companyName = "ZIJIN";
    await this.getPosition();
    await this.getCityAreaInfo();
    // await this.getStoreListInfo();
  },
};
</script>

<style lang="less" scoped>
.store-list {
  background: #fafafa;
  width: 7.5rem;
  height: 100vh;
  font-size: 15px;

  .header {
    display: flex;
    height: 40px;
    background: #fff;
    align-items: center;
    box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
  }

  .content {
    padding-bottom: 15px;
    background: #fafafa;
  }

  .title {
    display: flex;
    flex-direction: row;
    color: #666666;
    font-size: 13px;
    padding-left: 20px;
    align-items: center;

    .img {
      width: 8px;
      height: 6px;
      padding-left: 10px;
    }
  }

  .list {
    padding-top: 10px;
  }
}
</style>
